const TOPBAR = {
  GA_EVENT_CATEGORY: 'topbar',
};

export default TOPBAR;
